import "./EnterpriseContactModal.css";

const ENTERPRISE_FEATURES = [
  "Customized Reports",
  "Customized Sources",
  "Customized Alerts",
  "Customized Branding",
  "Custom To Your Workflow",
  "Unlimited Users",
  "Access literature review tools",
];

const CONTACT_US_URL = "https://www.medrpt.ai/contact-us";

const EnterpriseFeatureIcon = () => (
  <span className="enterprise-feature-icon" aria-hidden="true">
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="9" fill="currentColor" />
      <path
        d="M6 10.5L8.5 13L14 7.5"
        stroke="#fff"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

const EnterpriseContactModal = ({ onClose }) => {
  return (
    <div className="enterprise-modal-overlay" onClick={onClose}>
      <div className="enterprise-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="enterprise-modal-header">
          <h3>MedRPT Pricing Plans</h3>
          <button type="button" className="enterprise-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="enterprise-card">
          <div className="enterprise-card-label">ENTERPRISE</div>
          <h4 className="enterprise-card-heading">Contact Us</h4>
          <ul className="enterprise-card-features">
            {ENTERPRISE_FEATURES.map((feature) => (
              <li key={feature} className="enterprise-card-features-item">
                <EnterpriseFeatureIcon />
                <span className="enterprise-card-features-text">{feature}</span>
              </li>
            ))}
          </ul>
          <a
            href={CONTACT_US_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="enterprise-card-btn"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseContactModal;
